import React from 'react';
import { connect } from 'react-redux';
import { codeTimed } from '_helpers';
import styles from './Common.module.css'

class ActualCharges extends React.Component {

    render() {
        return (
            <div className={styles.computed_charges_wrapper}>
                <div className={styles.row}>
                    <span className={styles.time_label}>Total Minutes of Timed Therapy:</span>
                    <span className={styles.time}>{this.props.totalTimedMin}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.time_label}>Total Treatment Time:</span>
                    <span className={styles.time}>{this.props.totalTreatMin}</span>
                </div>
                <div className={styles.row}>
                    <div className={styles.diag_section_wrapper}>
                        <span className={styles.header_wrapper}>
                            <span className={styles.header_row}>
                                <span className={styles.header_col1}>Existing Charges:</span>
                            </span>
                        </span>

                        {Object.keys(this.props.charges)
                            .map(id => {
                                const charge = this.props.charges[id];
                                return (
                                    <div key={charge.ID}>
                                        {
                                            charge.trtcode + ' - ' +
                                            charge.trtdesc + ' - ' +
                                            charge.units + ' ' +
                                            (charge.units === 1 ? 'Unit' : 'Units') + ' ' +
                                            (codeTimed(charge.trtcode) ? 'Timed' : 'Untimed') +
                                            ' Code'
                                            + (charge.assistant ? ' (Assistant)' : '')
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let totalTimedMin = state.entities.notes.MLEXLOG[xlno].XLTOTALTIMEDMIN;
    let totalTreatMin = state.entities.notes.MLEXLOG[xlno].XLTOTALTREATMIN;

    let charges = Object.keys(state.entities.notes.CHARGES)
        .filter(key => state.entities.notes.CHARGES[key].NoteId === noteId)
        .sort((a, b) => state.entities.notes.CHARGES[a].chno - state.entities.notes.CHARGES[b].chno)
        .map(key => state.entities.notes.CHARGES[key]);

    return {
        charges,
        totalTimedMin,
        totalTreatMin
    };
}

const connectedActualCharges = connect(mapStateToProps)(ActualCharges);
export { connectedActualCharges as ActualCharges };

